module.exports = __webpack_public_path__ + "static/media/IMG_4282.7a236a40.PNG";